import styled from 'styled-components'

import {colour, spacing, media} from '../../../theme'

export const FeedbackButton = styled.a`
  position: fixed;
  bottom: 5%;
  right: 2%;
  cursor: pointer;
  opacity: 1;
  z-index: 2;
  visibility: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 3rem;
  padding: ${spacing.spacing2};
  font-size: 0;
  font-weight: 600;
  text-decoration: none;
  color: ${colour.palette.white};
  transition: none;
  border-radius: 5px;
  border: 0.125rem solid ${colour.palette.white};
  box-shadow: ${spacing.spacing0} 0.125rem ${spacing.spacing1} rgb(0 0 0 / 60%);
  box-sizing: border-box;
  background-color: #1a1a1a;

  ${({isSticky}) => isSticky && `background-color: #1A1A1A;`}

  &:hover {
    background-color: ${colour.palette.greyscale20};
    text-decoration: none;
    color: ${colour.palette.white};
  }

  &:focus {
    background-color: ${colour.palette.systemButtonGrey};
    box-shadow: 0 0 0 4px ${colour.palette.systemFocusBlue},
      0 3px 5px 3px rgba(0, 0, 0, 0.6);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:active {
    background-color: ${colour.palette.backgroundGrey};
    box-shadow: 0 0 0 4px ${colour.palette.systemFocusBlue},
      0 5px 7px 3px rgba(0, 0, 0, 0.6);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:visited {
    color: ${colour.palette.white};
  }

  @media ${media.mobile} {
    display: block;
    padding: ${spacing.spacing2};
    width: 3rem;
    height: 3rem;
  }

  @media ${media.small} {
    display: flex;
    flex-direction: column;
    height: 5rem;
    width: auto;
    padding: 0.375rem ${spacing.spacing3} 0.563rem ${spacing.spacing3};
    font-size: 1rem;
  }

  @media ${media.medium} {
    height: 3rem;
    width: auto;
    padding: ${spacing.spacing2} ${spacing.spacing4} ${spacing.spacing2}
      ${spacing.spacing3};
  }

  @media print {
    display: none;
  }
`

export const FeedbackImage = styled.i`
  display: inline-block;
  background: url('./images/ontario-rate-review.svg');
  background-size: 100%;
  background-repeat: no-repeat;
  width: 2rem;
  height: 2rem;
  margin: 0;

  @media ${media.small} {
    display: block;
    margin: 0.0625rem auto ${spacing.spacing1};
  }

  @media ${media.medium} {
    margin: 0.125rem ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing0};
  }
`

export const FeedbackText = styled.span`
  display: inline-block;

  @media ${media.small} {
    display: block;
  }

  @media ${media.medium} {
    display: flex;
  }
`

export const FeedbackButtonContainer = styled.span`
  display: flex;
  align-items: center;

  @media ${media.small} {
    display: block;
  }

  @media ${media.medium} {
    display: flex;
  }
`
